<script setup lang="ts">
import GaiaText from '../base/GaiaText.vue';
import GaiaTriggerGlyph from './GaiaTriggerGlyph.vue';
import { gaiaAccent } from '../themes/tokens';

const props = defineProps({
  /** Uppercase label before the control. */
  label: {
    type: String,
    default: 'Trigger',
  },
});

const accent = gaiaAccent.base;
const border = gaiaAccent.border;
const wash = gaiaAccent.wash;
</script>

<template>
  <!-- A group's trigger condition (Playbooks mock): accent strip with the
       bolt glyph and the condition control in the default slot. -->
  <n-flex align="center" :size="9" :wrap="false" class="gaia-trigger-row">
    <gaia-trigger-glyph :color="accent" :style="{ flex: 'none' }" />
    <gaia-text
      variant="label"
      size="nano"
      :style="{ flex: 'none', whiteSpace: 'nowrap', color: accent }"
    >
      {{ props.label }}
    </gaia-text>
    <span :style="{ flex: 1, minWidth: 0 }"><slot /></span>
  </n-flex>
</template>

<style scoped>
.gaia-trigger-row {
  padding: 9px 12px;
  border: 1px solid v-bind(border);
  border-radius: 10px;
  background: v-bind(wash);
}
</style>
